import onDOMContentLoaded from '../utils/on-dom-content-loaded';

const initEditorSearch = () => {
  const editorSearch = document.getElementById('editor-search');
  if (!editorSearch) {
    return;
  }

  document.querySelector('#editor-search .js-copy').addEventListener('click', () => {
    const copyText = document.getElementById('query-string');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  });

  document.querySelector('#editor-search #apply-filter').addEventListener('click', (e) => {
    e.preventDefault();
    const facets = [];
    const types = [];
    const query = [];
    const addToQuery = (item) => {
      if (item) {
        query.push(item);
      }
    };

    const searchString = document.getElementById('search-term').value;
    const sortBy = document.querySelector('input[name="sortby"]:checked').value;
    document.querySelectorAll('.facet').forEach((v) => {
      const checked = Array.from(v.querySelectorAll('input[type="checkbox"]'))
        .filter((facetCheckbox) => facetCheckbox.checked)
        .map((facetValue) => facetValue.value)
        .join(',');
      if (checked) {
        facets.push(`${v.dataset.facet}:${checked}`);
      }
    });

    document.querySelectorAll('.type').forEach((v) => {
      const checked = Array.from(v.querySelectorAll('input[type="checkbox"]'))
        .filter((facetCheckbox) => facetCheckbox.checked)
        .map((facetValue) => facetValue.value)
        .join(',');
      if (checked) {
        types.push(checked);
      }
    });

    const facet = facets.join('|');
    const type = types.join('|');
    const url = '/editor-search';
    addToQuery(searchString ? `searchstring=${encodeURIComponent(searchString)}` : '');
    addToQuery(facet ? `facets=${facet}` : '');
    addToQuery(type ? `type=${type}` : '');
    addToQuery(sortBy ? `sortby=${sortBy}` : 'sortby=top-results');
    const queryString = query.join('&');
    window.location.href = `${url}${queryString ? `?${queryString}` : ''}`;
  });
};

onDOMContentLoaded().then(() => initEditorSearch());
